/* eslint-disable react-hooks/exhaustive-deps */
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import {getCroppedPicture} from '../../modules/imageHandler';
import CurrencyFormat from 'react-currency-format';
import React, {useEffect, useMemo, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {
  SELECTOR_SHOPPING_CART_PRODUCTS,
  SELECTOR_SHOPPING_CART_PRODUCTS_COUNT,
  SELECTOR_SHOPPING_CART_PRODUCTS_RELATED,
} from '../../redux/selectors/shoppingCart';
import {useSelector} from 'react-redux';
import {SELECTOR_FULFILLMENT_CURRENT} from '../../redux/selectors/fulfillments';
import numeral from 'numeral';
import {SELECTOR_DISCOUNT} from '../../redux/selectors/discounts';
import {SELECTOR_PAY_METHOD} from '../../redux/selectors/methopay';
import {Swiper, SwiperSlide} from 'swiper/react';
import {useMediaQuery} from '@material-ui/core';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.min.css';
import ItemProduct from '../../components/makeComponents/components/ItemProduct';
import './product.css';

const useStylesItemProduct = makeStyles((t) => ({
  productContent: {
    position: 'relative',
  },
  productImageContent: {
    overflow: 'hidden',
    border: `1px solid ${t.palette.divider}`,
    width: 80,
    height: 80,
    minWidth: 80,
    minHeight: 80,
    borderRadius: 10,
  },
  productImage: {
    height: 80,
    maxWidth: '100%',
    maxHeight: '100%',
  },
  productCount: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    top: -5,
    right: -5,
    width: 20,
    height: 20,
    borderRadius: 100,
    backgroundColor: 'red',
    color: 'white',
  },
  tag: {
    backgroundColor: '#1374ee',
    color: 'white',
    fontWeight: 'normal',
    fontSize: '12px',
    borderRadius: '5px',
    padding: '2px 6px',
  },
}));

function ItemProductList({data}) {
  const selectpay = useSelector(SELECTOR_PAY_METHOD);

  const urlImage = useMemo(
    () =>
      getCroppedPicture(data.product.main_media?.path, {
        width: 80,
        height: 80,
      }),
    [data.product.main_media?.path],
  );

  const classes = useStylesItemProduct();

  function getPrice(product) {

    const priceData = product.product_price_list;

    let productPrice = 0;

    if (priceData) {
      productPrice = priceData.price; // Se toma el precio de la lista de precios de la empresa
    } else if (selectpay !== 'credit' && product.discount_price) {
      productPrice = product.discount_price; // No hay lista de precios, no es pago a crédito y el producto tiene descuento
    } else if (selectpay !== 'credit' && !product.discount_price) {
      productPrice = product.price; // No hay lista de precios, no es pago a crédito y el producto no tiene descuento
    } else if (selectpay === 'credit' && product.settlement === 'false') {
      productPrice = product.price; // No hay lista de precios, es pago a crédito y el producto no está en liquidación
    } else {
      productPrice = product.discount_price || product.price; // No hay lista de precios, es pago a crédito y el producto está en liquidación
    }

    return productPrice * data.quantity;
  }

  return (
    <Box pb={2} display="flex" alignItems="center">
      <Box className={classes.productContent}>
        <Box className={classes.productImageContent}>
          <img className={classes.productImage} src={urlImage} alt="product" />
        </Box>
        <Box className={classes.productCount}>{data.quantity}</Box>
      </Box>
      <Box mx={2}>
        {data.product.oversize === 'true' ? <span className={classes.tag}>Oversize</span> : null}
        <Typography variant="body1">{data.product.name}</Typography>
      </Box>
      <CurrencyFormat
        value={numeral(getPrice(data.product) || 0).format('0,0')}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
        renderText={(value) => <Typography variant="body2">{value}</Typography>}
      />
    </Box>
  );
}

export function ViewTotals() {
  const products = useSelector(SELECTOR_SHOPPING_CART_PRODUCTS);
  const productsCount = useSelector(SELECTOR_SHOPPING_CART_PRODUCTS_COUNT);
  const productsRelated = useSelector(SELECTOR_SHOPPING_CART_PRODUCTS_RELATED);
  const fulfillment = useSelector(SELECTOR_FULFILLMENT_CURRENT);
  const discount = useSelector(SELECTOR_DISCOUNT);
  const selectpay = useSelector(SELECTOR_PAY_METHOD);
  const isMobil = useMediaQuery('(max-width:767px)');

  const [details, setDetails] = useState({tax: 0, subTotal: 0});

  useEffect(() => {
    if (productsCount) {
      let tax = 0;
      const prices = products.map((item) => {
        let productPrice;

        if (item.product.product_price_list) {
          productPrice = item.product.product_price_list.price; // Se toma el precio de la lista de precios de la empresa
          tax +=
            item.quantity * item.product.product_price_list.price_with_tax
              ? item.product.product_price_list.price_with_tax - item.product.product_price_list.price
              : 0;
        } else if (selectpay !== 'credit' && item.product.discount_price) {
          tax += item.quantity * (item.product.discount_price * (item.product.tax_rule_value / 100));
          productPrice = item.product.discount_price; // No hay lista de precios, no es pago a crédito y el producto tiene descuento
        } else if (selectpay !== 'credit' && !item.product.discount_price) {
          tax += item.quantity * (item.product.price * (item.product.tax_rule_value / 100));
          productPrice = item.product.price; // No hay lista de precios, no es pago a crédito y el producto no tiene descuento
        } else if (selectpay === 'credit' && item.product.settlement === 'false') {
          tax += item.quantity * (item.product.price * (item.product.tax_rule_value / 100));
          productPrice = item.product.price; // No hay lista de precios, es pago a crédito y el producto no está en liquidación
        } else {
          productPrice = item.product.discount_price || item.product.price; // No hay lista de precios, es pago a crédito y el producto está en liquidación
          tax +=
            item.quantity * ((item.product.discount_price || item.product.price) * (item.product.tax_rule_value / 100));
        }

        return item.quantity * productPrice;
      });

      setDetails({
        subTotal: Math.trunc(prices.reduce((acc, current) => acc + current, 0)),
        tax: Math.trunc(tax),
      });
    }
  }, [products, discount]);

  const ProductOversize = products?.some((item) => item.product.oversize === 'true');

  return (
    <div>
      {products.map((item, i) => (
        <ItemProductList key={i} data={item} />
      ))}
      {ProductOversize ? (
        <p style={{lineHeight: 1.2, fontSize: 13, padding: '0px 10px', color: 'red'}}>
          Los productos oversize no aplican para envío gratis
        </p>
      ) : null}
      <Divider />
      <Box py={2}>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body1">Subtotal:</Typography>
          <CurrencyFormat
            value={details.subTotal}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
            renderText={(value) => <Typography variant="body1">{value}</Typography>}
          />
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body1">*Envio:</Typography>
          {(fulfillment?.price || 0) !== 0 ? (
            <CurrencyFormat
              value={fulfillment.price}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              renderText={(value) => <Typography variant="body1">{value}</Typography>}
            />
          ) : (
            <Typography variant="body1">No calculado</Typography>
          )}
        </Box>
        {fulfillment?.discount > 0 && (
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body1">Descuento de Envio:</Typography>
            <CurrencyFormat
              value={fulfillment.discount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={'$'}
              renderText={(value) => <Typography variant="body1">- {value}</Typography>}
            />
          </Box>
        )}
        {!!discount && (
          <Box display="flex" justifyContent="space-between">
            <Typography variant="body1">Descuento:</Typography>
            <Typography variant="body1">- {numeral(discount?.extra?.total_discount_amount).format('$ 0,0')}</Typography>
          </Box>
        )}
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body1">Iva:</Typography>
          <CurrencyFormat
            value={Number(
              (!discount || discount?.extra?.discount_apply_to === 'shipment'
                ? details.tax
                : details.tax * (1 - discount?.extra?.total_discount_percentage / 100)
              ).toFixed(2),
            )}
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
            renderText={(value) => <Typography variant="body1">{value}</Typography>}
          />
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="body2">Total:</Typography>
          <CurrencyFormat
            value={
              discount
                ? (discount?.extra.discount_apply_to === 'shipment'
                    ? (fulfillment?.price || 0) - (discount?.extra?.total_discount_amount || 0) + details.subTotal
                    : details.subTotal + (fulfillment?.price || 0)) +
                  (discount?.extra?.tax_after_discount || details?.tax) -
                  (discount?.extra?.total_discount_amount || 0)
                : details.subTotal + (fulfillment?.price || 0) + details.tax
            }
            displayType={'text'}
            thousandSeparator={true}
            prefix={'$'}
            renderText={(value) => <Typography variant="body2">{value}</Typography>}
          />
        </Box>
        <div className="product_related" style={{display: 'block', paddingTop: 30}}>
          <h3>
            <b>Productos que podrían interesar</b>
          </h3>
          <Swiper
            key={isMobil ? 'm' : 'd'}
            spaceBetween={5}
            slidesPerView={isMobil ? 1 : 2}
          >
            {productsRelated
              .filter((_, i) => i < 10)
              .map((itemData, i) => (
                <SwiperSlide key={i}>
                  <ItemProduct data={itemData} />
                </SwiperSlide>
              ))}
          </Swiper>
        </div>
      </Box>
    </div>
  );
}
